import { Fragment } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset } from '@opallabs/kuiper'
import { AccountName } from '@opallabs/periodic/src/AccountName'
import { ContentAvatar } from '@opallabs/periodic/src/ContentAvatar'
import { sharedColors } from '../../../sharedStyles/styles'
import { styles } from './styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  image: AssetReference | null
  isPresenting: boolean
  onExpandAsset: (assetId: number) => void
  onRemoveAsset: (assetId: number) => void
  readOnly: boolean
}

export const MobileStandard: React.FC<Props> = ({
  accountImage,
  accountName,
  image,
  isPresenting,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
}) => (
  <Fragment>
    <Asset
      hasAssetOverlay={!readOnly || isPresenting}
      assetReference={image}
      placeholder={!image}
      overrideStyles={{
        asset: styles.coverAsset,
        assetBase: styles.coverAsset,
      }}
      onEmbiggen={() => onExpandAsset(image?.id || 0)}
      onRemove={() => onRemoveAsset(image?.id || 0)}
    />
    <div css={styles.channel}>
      <ContentAvatar
        size={53}
        style={styles.avatar}
        assetReference={accountImage}
      />
      <AccountName
        name={accountName}
        style={styles.accountName}
        size={25}
        color={sharedColors.black}
      />
      <div css={styles.subscribeBtn}>Subscribe</div>
      <div css={styles.footer}># subscribers &middot; # videos</div>
    </div>
  </Fragment>
)
